import i18n from 'src/i18n';
import { Posts } from '../posts';
import { Header, Title } from './activities.styles';
import { ActivitiesProps } from './activities.types';

const Activities = ({ theme }: ActivitiesProps) => {
  return (
    <section>
      <Header theme={theme} className="_position-sticky">
        <Title className="_text-gray-900 _font-weight-bold _text-uppercase _px-4 _py-4 _mb-0">
          {i18n.t('profile.activities.title')}
        </Title>
      </Header>

      <Posts />
    </section>
  );
};

export default Activities;
